<template>
  <section class="container columns" style="margin: 2% auto">
    <form v-on:submit.prevent="createEquipment" class="column is-half">
      <b-field label="Equipment Type">
        <b-select
          v-model="newEquipment.equipmentTypeId"
          placeholder="Select a type"
          :loading="equipmentTypesLoading == true"
          required
        >
          <option
            v-for="option in equipmentTypes"
            :value="option.id"
            :key="option.id"
          >
            {{ option.name }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Province">
        <b-select
          v-model="newEquipment.province"
          placeholder="Select a type"
          :loading="provincesLoading == true"
          required
        >
          <option
            v-for="option in provinces"
            :value="option._id"
            :key="option._id"
          >
            {{ option.provinceName }}
          </option>
        </b-select>
      </b-field>
      <b-field label="District">
        <b-select
          v-model="newEquipment.district"
          placeholder="Select a type"
          required
        >
          <option
            v-for="option in districts"
            :value="option._id"
            :key="option._id"
          >
            {{ option.districtName }}
          </option>
        </b-select>
      </b-field>

      <b-field label="Name">
        <b-input v-model="newEquipment.name" placeholder required></b-input>
      </b-field>
      <b-field label="Quantity">
        <b-input v-model="newEquipment.quantity" placeholder required></b-input>
      </b-field>
      <b-field label="Ward">
        <b-input v-model="newEquipment.ward" placeholder required></b-input>
      </b-field>
      <!-- <b-field label="District">
              <b-input v-model="newEquipment.district" placeholder required></b-input>
            </b-field>
            <b-field label="Province">
              <b-input v-model="newEquipment.province" placeholder required></b-input>
            </b-field> -->
      <b-field label="Description">
        <b-input type="textarea" v-model="newEquipment.description"></b-input>
      </b-field>
      <!-- <b-field label="Currencies">
                <b-select
                    :native-size="currencies.length"
                    multiple
                    v-model="newEquipment.currencies">
                    <option  v-for="(currency, index) in currencies" :key="index" :value="currency" v-text="currency"></option>
                </b-select>
            </b-field> -->

      <div>
        <button class="button is-primary" type="submit">Create</button>
      </div>
    </form>
  </section>
</template>

<script>
import { currencies } from "@/helpers";
import { mapGetters } from "vuex";
export default {
  name: "newEquipment",
  data() {
    return {
      equipmentTypes: [],
      provinces: [],
      districts: [],
      currencies,
      newEquipment: {
        equipmentTypeId: "",
        name: "",
        ward: "",
        district: "",
        province: "",
        description: "",
        quantity: 0
      }
    };
  },
  computed: {
    isAvailableStr() {
      return this.newEquipment.available === "true"
        ? "Available"
        : "Not Available";
    },
    showUSDPrice() {
      return this.newEquipment.currencies.indexOf("USD") != -1;
    },
    showBondPrice() {
      return this.newEquipment.currencies.indexOf("ZW") != -1;
    },
    isRetailProduct() {
      return this.newEquipment.type === "retail";
    }
  },
  created() {
    this.getEquipmentTypes();
    this.getProvinces();
    // this.getDistricts()
    // getDistrictsForProvince();
  },
  watch: {
    "newEquipment.province": function(newProvinceId) {
      // Fetch districts for the selected province and update the districts list
      this.getDistrictsForProvince(newProvinceId);
      console.log("Watching here");
    }
  },
  methods: {
    getEquipmentTypes() {
      this.equipmentTypesLoading = true;
      this.$store
        .dispatch("getEquipmentTypes")
        .then(({ meta, equipmentTypes }) => {
          this.equipmentTypesLoading = false;
          if (equipmentTypes && equipmentTypes.length) {
            this.equipmentTypes = equipmentTypes;
          } else {
            this.$toasted.global.error("Product Types not found.");
          }
        })
        .catch(e => {
          this.equipmentTypesLoading = false;
          console.log("Exception when getting product types", e);
          this.$toasted.global.error("Failed to get product types.");
        });
    },
    getProvinces() {
      this.provincesLoading = true;
      this.$store
        .dispatch("getProvinces")
        .then(({ meta, provinces }) => {
          // console.log(provinces.length)
          this.provincesLoading = false;
          if (provinces && provinces.length) {
            this.provinces = provinces;
          } else {
            this.$toasted.global.error("Provinces not found.");
          }
        })
        .catch(e => {
          this.provincesLoading = false;
          console.log("Exception when getting Provinces", e);
          this.$toasted.global.error("Failed to get Provinces.");
        });
    },
    // getDistricts() {
    //   this.districtsLoading = true;
    //   this.$store.dispatch('getDistricts').then(({meta,districts})=> {
    //     this.districtsLoading = false;
    //     if(districts && districts.length) {
    //       this.districts = districts;
    //     } else {
    //       this.$toasted.global.error('Districts not found.');
    //     }
    //   }).catch(e=> {
    //     this.districtsLoading = false;
    //     console.log('Exception when getting Districts',e);
    //     this.$toasted.global.error('Failed to get Districts.');
    //   })
    // },

    getDistrictsForProvince(provinceId) {
      this.districtsLoading = true;
      this.$store
        .dispatch("getDistricts", provinceId)
        .then(({ meta, districts }) => {
          this.districtsLoading = false;
          console.log(districts);
          if (districts && districts.length) {
            this.districts = districts;
          } else {
            this.$toasted.global.error(
              "Districts not found for the selected province."
            );
          }
        })
        .catch(e => {
          this.districtsLoading = false;
          console.log("Exception when getting Districts", e);
          this.$toasted.global.error(
            "Failed to get Districts for the selected province."
          );
        });
    },
    createEquipment() {
      const loading = this.$loading.open();

      this.$store
        .dispatch("createEquipment", this.newEquipment)
        .then(newEquipment => {
          loading.close();
          this.$router.push({ name: "Equipment" });
          this.$toasted.global.success("Equipment Created!");
        })
        .catch(e => {
          console.log("Exception when creating product", e);
          loading.close();
          this.$toasted.global.error("Failed to create equipment type.");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Equipment/NewEquipment.vue